import styled from '@emotion/styled';
import type { PlanBadgeProps } from '@hotjar/hotsauce';
import { tokens, Badge, PlanBadge } from '@hotjar/hotsauce';
import type { AllBadgeStatus } from '@hotjar/hotsauce/build/components/Badge/BaseBadge';

const ContentGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${tokens.spacer.x1};
  flex-grow: 1;
  flex-shrink: 1;
  overflow: hidden;
`;

const Badges = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-grow: 0;
  align-items: center;
  gap: ${tokens.spacer.x1};
`;

export type OptionContentProps = {
  children: React.ReactNode;
  badge?: AllBadgeStatus;
  planBadge?: PlanBadgeProps['kind'];
};

const OptionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  gap: ${tokens.spacer.x1};
  white-space: nowrap;
  flex-grow: 1;
  overflow: hidden;
`;

export const OptionContent = ({ children, badge, planBadge }: OptionContentProps): JSX.Element => {
  return (
    <OptionContainer>
      <ContentGroup>{children}</ContentGroup>
      <Badges>
        {planBadge !== undefined && <PlanBadge kind={planBadge} size="s" />}
        {badge !== undefined && <Badge kind={badge} size="s" />}
      </Badges>
    </OptionContainer>
  );
};

export type AdvancedOptionProps = {
  // FIXME: These appear to be unused.
  // eslint-disable-next-line react/no-unused-prop-types
  id: string;
  // eslint-disable-next-line react/no-unused-prop-types
  value: string;
  children: React.ReactNode;
  badge?: AllBadgeStatus;
  planBadge?: PlanBadgeProps['kind'];
};

export const AdvancedOption = ({
  children,
  badge,
  planBadge,
}: AdvancedOptionProps): JSX.Element => {
  return (
    <OptionContent badge={badge} planBadge={planBadge}>
      {children}
    </OptionContent>
  );
};
